import { useContext, useMemo } from 'react';
import {
	FullPrice,
	ImageWrapper,
	Months,
	PlanWrapper,
	PromoPrice,
	SzeryfDesktop,
	TextInformationWrapper,
	Title,
} from './plan.styles';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { useLanguageData } from '@/common/hooks/useLanguageData';

import PromoMockup from '../../images/telefon - niebieski.png';
import Mockup from '../../images/telefon - fiolet.png';

import RibbonCZ from '../../images/cs/cz_gwarancja_desktop.png';
import RibbonHU from '../../images/hu/hu_gwarancja_desktop.png';
import RibbonSK from '../../images/sk/sk_gwarancja_desktop.png';

const MOCKUPS_CONFIG = {
	cs: {
		promo: PromoMockup,
		basic: Mockup,
		ribbon: RibbonCZ,
	},
	sk: {
		promo: PromoMockup,
		basic: Mockup,
		ribbon: RibbonHU,
	},
	hu: {
		promo: PromoMockup,
		basic: Mockup,
		ribbon: RibbonSK,
	},
};

const Plan = ({ promo, selectedOption }) => {
	const { lang, ltl } = useContext(LanguageContext);
	const translations = useLanguageData('checkout');

	const displayData = useMemo(() => {
		const result = {
			title: translations?.invidualPlan[ltl || 'en'],
			months: `${selectedOption?.inAppPrice?.label}`,
			fullPrice: {
				mid: selectedOption?.inAppPrice?.orginal_full_price,
			},
			promoPrice: `${translations.nowOnly} ${selectedOption?.full_price} ${translations.currencySign}`,
		};
		if (selectedOption?.type?.value === 'BASIC') {
			result.fullPrice = {};
		}

		if (promo) {
			result.fullPrice = {
				mid: selectedOption?.inAppPrice?.orginal_full_price,
			};
			result.promoPrice = `${translations.nowOnly} ${selectedOption?.promo_full_price} ${translations.currencySign} `;
		}

		return result;
	}, [selectedOption, promo]);

	return (
		<PlanWrapper>
			<ImageWrapper>
				<img
					src={
						promo ? MOCKUPS_CONFIG[lang]?.promo : MOCKUPS_CONFIG[lang]?.basic
					}
				/>
				<div>{displayData.months}</div>
			</ImageWrapper>
			<TextInformationWrapper>
				<Title>{displayData.title}</Title>
				<Months>({displayData.months})</Months>
				<FullPrice>
					<s>{displayData?.fullPrice?.mid}</s>
				</FullPrice>
				<PromoPrice>{displayData.promoPrice?.replace('.', ',')}</PromoPrice>
			</TextInformationWrapper>
			<div style={{ flex: 1 }} />
			<SzeryfDesktop>
				<img src={MOCKUPS_CONFIG[lang].ribbon} />
			</SzeryfDesktop>
		</PlanWrapper>
	);
};

export default Plan;
